// @flow
import * as React from 'react'
import { Layout } from 'antd'
import LocationContext from './LocationContext'
import AppHeader from './components/AppHeader'
import ListingContainer from './components/ListingContainer'
import 'antd/dist/antd.css'
import './App.css'

const { Header, Content } = Layout

type AppState = {
  detailOpen: boolean,
  toggleDetailOpen: () => void,
}

class App extends React.Component<{}, AppState> {
  constructor(props) {
    super(props)

    this.toggleDetailOpen = () =>
      this.setState(prevState => ({
        detailOpen: !prevState.detailOpen,
      }))

    this.state = {
      detailOpen: false,
      toggleDetailOpen: this.toggleDetailOpen,
    }
  }

  render() {
    return (
      <LocationContext.Provider value={this.state}>
        <Layout className={this.state.detailOpen ? 'detail-open' : ''}>
          <Header>
            <AppHeader />
          </Header>
          <Content>
            <ListingContainer />
          </Content>
        </Layout>
      </LocationContext.Provider>
    )
  }
}

export default App
